module.exports = __webpack_public_path__ + "c01edf693135a30c385073065987f85b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/rating/star.png
// module id = ./assets/images/rating/star.png
// module chunks = 0